import { useCallback, useEffect } from "react";
import { useBasePage } from "../../hooks/useBasePage";
import type { Customer } from "../../models/Customer";
import { DataState } from "../../models/DataState";
import { Status } from "../../models/Status";
import { CustomerService } from "../../services/CustomerService";
import { CustomerDTO } from "./CustomerDTO";

const initialState: CustomerDTO = {
  searchText: "",
  status: Status.Active,
  skip: 0,
  limit: 20,
  total: 0,
  isDialogOpen: false,
  dialogMode: "Create",
  selectedData: {
    DataState: DataState.New,
    Code: "",
    BusinessName: "",
    // FirstName: "",
    // LastName: "",
    AllowCreditSale: false,
    CreditLimit: 0,
    DefaultCreditDays: 0,
    MutePreDuePaymentNotification: false,
    CreditSaleRequiresApproval: false,
    MailAddress: "",
    PhoneNumber: "",
    Status: Status.Active,
    UserCode: "",
    Password: "",
  },
  customers: [],
};
export function useCustomer() {
  const { state, setState, setStateProperty, setStateProperties } =
    useBasePage<CustomerDTO>(initialState);
  const customerService = CustomerService();
  const { skip, limit, customers } = state;
  useEffect(() => {
    initialize();
  }, []);
  const initialize = useCallback(async (): Promise<void> => {
    const data = await customerService.GetAll(skip, limit);
    setStateProperties({
      skip: data.Skipped,
      limit: data.Limit,
      customers: data.Data,
    });
  }, [customers]);
  return { customers };
}
